export enum FlespiDeviceType {
    Unknown = 0,
    Scania_FMS = 145,
    Test = 4,
    TeltonikaGeneric = 19,
    Teltonika_FMB920 = 22,
    Teltonika_FMB001 = 23,
    Teltonika_FMB010 = 98,
    Teltonika_FMB900 = 99,
    Teltonika_FMB962 = 100,
    Teltonika_FMB964 = 101,
    Teltonika_FMB120 = 102,
    Teltonika_FMB122 = 103,
    Teltonika_FMB125 = 104,
    Teltonika_FMA110 = 105,
    Teltonika_FMA120 = 106,
    Teltonika_FMA202 = 107,
    Teltonika_FMA204 = 108,
    Teltonika_FMB630 = 187,
    Teltonika_FMB202 = 302,
    Teltonika_FMB204 = 303,
    Teltonika_FMB640 = 308,
    Teltonika_FMT100 = 353,
    Teltonika_FMB110 = 367,
    Teltonika_FMB130 = 501,
    Teltonika_FMU125 = 504,
    Teltonika_FMU130 = 505,
    Teltonika_MTB100 = 506,
    Teltonika_FMC125 = 577,
    Teltonika_FMM125 = 578,
    Teltonika_FMC130 = 579,
    Teltonika_FMM130 = 580,
    Teltonika_FMB206 = 581,
    Teltonika_FMC001 = 582,
    Teltonika_FMM001 = 584,
    Teltonika_FMC640 = 645,
    Teltonika_FMM640 = 646,
    Teltonika_FMB140 = 692,
    Teltonika_FMB910 = 693,
    Teltonika_FMP100 = 743,
    Teltonika_FMB002 = 744,
    Teltonika_FMB003 = 745,
    Teltonika_MSP500 = 753,
    Teltonika_FMB020 = 841,
    Teltonika_FMB965 = 1217,
    Teltonika_FMB209 = 1218,
    Teltonika_FMB225 = 1219,
    Teltonika_FMB230 = 1220,
    Teltonika_FMB240 = 1221,
    Teltonika_FMB641 = 1222,
    Teltonika_FMC225 = 1294,
    Teltonika_FMC230 = 1295,
    Teltonika_FMM230 = 1296,
    Teltonika_FMC003 = 1303,
    Teltonika_FMM003 = 1304,
    Teltonika_FMC00A = 1336,
    Teltonika_FMM00A = 1337,
    Teltonika_FMC920 = 1338,
    Teltonika_FMB150 = 1339,
    Teltonika_FMC150 = 1340,
    Teltonika_FMC800 = 2129,
    Teltonika_FMM800 = 2130,
    Teltonika_FMM920 = 2131,
    Teltonika_FMM150 = 2132,
    Teltonika_FMC13A = 2138,
    Teltonika_FMM13A = 2139,
    Teltonika_FMC650 = 2147,
    Teltonika_FMM80A = 2226,
    Teltonika_FMM650 = 2227,
    Teltonika_FMB930 = 2229,
    Teltonika_FMM880 = 2284,
    Teltonika_FMC880 = 2285,
    Teltonika_FMC234 = 2334,
    Teltonika_FMC250 = 2604,
    Teltonika_FMM250 = 2605,

}
